import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, map, Observable, of } from 'rxjs';
import { catchError, take, tap } from "rxjs/operators";
import { AuthService } from './auth.service';
import { SortType } from '@lcms/shared/helpers';
import { MissingFieldsModel } from '../models/missing-fields';
import {an} from "@fullcalendar/core/internal-common";

@Injectable({
  providedIn: 'any'
})
export class UserHttpService {
  constructor(private httpClient: HttpClient, private authservice: AuthService) {
     // this.getUserCGU()
    }

  getUserRole(): Observable<any> {
    const payload = { scopes: ["role"] }
    return this.httpClient.post<any>('api/access/v1/set/user/scope', payload).pipe(
      catchError(err => {
        console.error(err);
        this.authservice.logout().pipe(take(1)).subscribe()
        // Handle the error as you wish. Here, we return an Observable of null value.
        return of(null);
      })
    );
  }

  getUserRoleByAdmin(payload: any): Observable<any> {
    return this.httpClient.get<any>('api/access/v1/get/user/role/' + payload);
  }

  getProfileByUserId(userId: any = ''): Observable<any> {
    return this.httpClient.get<any>('api/user/v1/get/' + userId);
  }

  getProfile(user_id: number | string = ''): Observable<any> {
    console.log('in http service', user_id);
    const url = user_id ? '/api/user/v1/get/data/' + user_id : '/api/user/v1/get/data'
    return this.httpClient.get<any>(url);
  }
  getAllProfile(user_id: number | string = ''): Observable<any> {
    const url = user_id ? '/api/user/v1/get/profile/' + user_id : '/api/user/v1/get/profile'
    return this.httpClient.get<any>(url)
  }

  setProfileData(payload: any): Observable<any> {
    return this.httpClient.post('api/auth/v1/set/user/info', payload)
  }

    getUserData(userId:any=''): Observable<any> {
    if(userId){
      return this.httpClient.get<any>('/api/auth/v1/get/user/'+userId);
    }else{
      return this.httpClient.get<any>('/api/auth/v1/get/user');

    }
    }

  setAvatar(payload: any): Observable<any> {
    return this.httpClient.post<any>('api/auth/v1/set/avatar', payload);
  }

  getUsers(): Observable<any> {
    return this.httpClient.get<any>('api/auth/v1/get/users');
  }
  getPaginateUsers(page:number,searchTerm:string):Observable<any>{
    searchTerm = (searchTerm)? encodeURIComponent(searchTerm) : 'NULL';
    return this.httpClient.get<any>('api/auth/v1/get/users/search/'+searchTerm +'?page='+page);
  }
  getUsersByGroups(payload: any, sort: SortType | null = null , status : any| null = null , filterRole : any | null =null): Observable<any> {
    const params = (sort && sort?.name?.length > 0) ? `&orderby=${sort.name}&type=${sort.order}` : '';
    const query  =status && status.status  ? `&status=${status?.status}` :''
    const roles = (filterRole && filterRole.length > 0) ? `&role=${filterRole.map((role :any)=>role.slug).join(',')}` : '';
    return this.httpClient.get<any>('api/auth/v1/get/users/search/' + encodeURIComponent(payload.search) + '/' + payload.group_id + '?page=' + payload.page + params +query+roles);
  }

  getMissingFields(){
    return this.httpClient.get<{ data: MissingFieldsModel[] }>('api/auth/v1/get/missingfields');
  }

  setMissingFields(payload: any): Observable<any> {
    return this.httpClient.post('api/auth/v1/set/missingfields', payload)
  }

  setUserData(payload: any): Observable<any> {
    return this.httpClient.post('api/auth/v1/set/create', payload)
  }

  toggleActiveUser(payload: any): Observable<any> {
    return this.httpClient.post('api/auth/v1/set/users/status', payload)
  }

  deleteUsers(payload: any): Observable<any> {
    return this.httpClient.post('api/auth/v1/set/users/delete', payload)
  }

  searchUsers(payload: any): Observable<any> {
    return this.httpClient.get('api/auth/v1/get/users/search/' + encodeURIComponent(payload))
  }
  deleteMyAccount(payload: any): Observable<any> {
    return this.httpClient.post('api/auth/v1/set/delete', payload)
  }

  getAllRoles(): Observable<any> {
    return this.httpClient.get('api/access/v1/get/roles');
  }

  getUsersByIds(payload: { users_ids: any[] }): Observable<any> {
    return this.httpClient.post('api/auth/v1/get/users', payload);
  }

  getRolesByIds(payload: { roles_ids: any[] }): Observable<any> {
    return this.httpClient.post('api/access/v1/get/roles', payload);
  }

  getUserCGU(): Observable<boolean> {
    return this.httpClient.get("api/auth/v1/get/user").pipe(
      map((data: any) => data.data.conditions_accepted),
    )
  }

  setUserdata(payload: any): Observable<any> {
    return this.httpClient.post<any>('api/auth/v1/set/user', payload)
  }
  getTerms(): Observable<any> {
    return this.httpClient.get("/api/auth/v1/get/conditions")
  }
  getTags(payload: any): Observable<any> {
    return this.httpClient.get<any>(`/api/tag/v1/get/categories/${payload}`)
  }
   getInterest(page:number,searchTerm:string , check : number | null = null): Observable<any> {
    searchTerm = (searchTerm)? `search=${encodeURIComponent(searchTerm)}` : '';
    const checked = (check !==null) ? `&checked=${check}`:''
    return this.httpClient.get<any>(`/api/user/center-interest/v1/get/interests_tags?${searchTerm}&page=${page}${checked}`).pipe(
      map((data)=>data.data)
    )
  }
}
